// LIST_SETTINGS: "/settings",
//     GET_SETTINGS_BY_ID: "/settings",
//     GET_SETTINGS_BY_CHAINID: "/settings/chain",

export const LIST_SETTINGS_SUCCESS = "LIST_SETTINGS_SUCCESS";
export const GET_SETTINGS_BY_ID = "GET_SETTINGS_BY_ID";
export const GET_SETTINGS_BY_CHAINID = "GET_SETTINGS_BY_CHAINID";
